const Marquee = ({ items }) => {
    const row = items.map((t, i) => (
        <span key={i} className="flex items-center gap-8 sm:gap-12 shrink-0">
            <span className="font-serif italic text-2xl sm:text-4xl text-ivory/80 whitespace-nowrap">{t}</span>
            <span className="text-gold text-xs">◆</span>
        </span>
    ));
    return (
        <div className="overflow-hidden border-y border-gold/15 py-5 sm:py-7 select-none" aria-hidden="true">
            <div className="marquee-track flex gap-8 sm:gap-12 w-max">
                <div className="flex gap-8 sm:gap-12">{row}</div>
                <div className="flex gap-8 sm:gap-12">{row}</div>
            </div>
        </div>
    );
};

export default Marquee;
